import React from 'react';
import looppa from 'looppa';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Trans } from 'translations';
import { contentPages } from 'constants/menus';

export default function AmigosMenu({ tabIndex }) {
    return (
        [
            <h1 key="title" className="footer-head--title u-reset"><Trans path="footer.menu.title"/></h1>,
            <ul key="list" className="footer-head--list u-reset">
                {looppa(contentPages())(({ url, title }, i) => (
                    <li className="footer-head--item" key={i}>
                        <NavLink
                            tabIndex={tabIndex}
                            activeClassName="footer-head--link__is-active"
                            className="footer-head--link u-reset"
                            exact
                            to={url}
                        >
                            {title}
                        </NavLink>
                    </li>
                ))}
            </ul>,
        ]
    );
}

AmigosMenu.propTypes = {
    tabIndex: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-footer/footer-head/amigos-menu.js